import PreFaktorPrintBody from 'components/prefaktorComponents/prefaktorPrintBody/PreFaktorPrintBody';
import PreFaktorPrintFooter from 'components/prefaktorComponents/prefaktorPrintFooter/PreFaktorPrintFooter';
import PreFaktorPrintHeader from 'components/prefaktorComponents/prefaktorPrintHeader/PreFaktorPrintHeader';
import Loading from 'layouts/Loading/Loading';
import Axios from 'middleware/axiosInstance';
import React, { useEffect, useState } from 'react'
import { useParams } from 'react-router-dom';

const ShowOnePrefaktorFromServer = () => {

    // start react router url params
    const UrlParams = useParams();
    const factorId = UrlParams.id;
    // end react router url params


    const [prefactorInfoToShowAndPrint, setPrefactorInfoToShowAndPrint] = useState(null);
    const [prefactorItemsInfoToShowAndPrint, setPrefactorItemsInfoToShowAndPrint] = useState(null);
    const [showFactorssssss, setShowFactorssssss] = useState(false);

    const getPrefaktorInfo = () => {

        Axios.get(`/invoice/${factorId}`).then((res) => {
            console.log(res.data);
            setPrefactorInfoToShowAndPrint(res.data);

        })
            .then(() => {

                Axios.get(`/invoice_items/${factorId}`).then((res) => {
                    console.log(res.data);
                    setPrefactorItemsInfoToShowAndPrint(res.data);
                    setShowFactorssssss(true)
                });


            });
    }
    useEffect(() => {
        getPrefaktorInfo()
    }, []);

    return (
        <div className="customized-container">
            <div className="customized-wrapper">
                <h5 className="title-session d-print-none">
                    پیش فاکتور های صادره
                </h5>

                {
                    showFactorssssss ?
                        <div className="d-print-flex flex-column ">
                            <PreFaktorPrintHeader prefaktorInfo={prefactorInfoToShowAndPrint} />
                            <PreFaktorPrintBody
                                prefaktorInfo={prefactorItemsInfoToShowAndPrint}
                            />
                            <PreFaktorPrintFooter />
                        </div>
                        : <Loading />
                }
            </div>
        </div>
    )
}

export default ShowOnePrefaktorFromServer